Promise.all([
  import('../../plugins/semantic/popup.css'),
  import('../../plugins/semantic/popup'),
  import('../../scripts/dbs/dbs.utilities.querystring'),
]).then(() => {
  $('.widget.guest-selector').each(function (i, el) {
    $(el).data('widget', new GuestSelector(el))
    $(el).data('widget').init()
  })
})

function GuestSelector(el) {
  const self = this
  self.el = $(el)
  self.qs = new dbs.utilities.querystring()

  const ADULTS_DEFAULT_VALUE = 2
  const KIDS_DEFAULT_VALUE = 0
  const INFANTS_DEFAULT_VALUE = 0

  const guestsDisplayInput = self.el.find('.main-input')
  const guestsDisplayEl = self.el.find('.total-guests-value') // Found on 'book-now' and 'accommodation-availability' components
  const totalGuestsInput = self.el.find('.total.input')

  const adultsValue = self.el.find('.adults.value')
  const adultsInput = self.el.find('.adults.input')
  const adultsPlusButton = self.el.find('.plus-button[data-type="adults"]')
  const adultsMinusButton = self.el.find('.minus-button[data-type="adults"]')

  const kidsValue = self.el.find('.kids.value')
  const kidsInput = self.el.find('.kids.input')
  const kidsPlusButton = self.el.find('.plus-button[data-type="kids"]')
  const kidsMinusButton = self.el.find('.minus-button[data-type="kids"]')

  const infantsValue = self.el.find('.infants.value')
  const infantsInput = self.el.find('.infants.input')
  const infantsPlusButton = self.el.find('.plus-button[data-type="infants"]')
  const infantsMinusButton = self.el.find('.minus-button[data-type="infants"]')

  self.maxSleepingCapacity = self.el.attr('data-max-sleeping-capacity')
    ? parseInt(self.el.attr('data-max-sleeping-capacity'))
    : 10

  self.maxAdultCapacity = self.el.attr('data-max-adult-capacity') ? self.el.attr('data-max-adult-capacity') : self.maxSleepingCapacity

  self.maxKidCapacity = self.el.attr('data-max-kid-capacity') ? parseInt(self.el.attr('data-max-kid-capacity')) : 10

  self.maxInfantCapacity = self.el.attr('data-max-infant-capacity')
    ? parseInt(self.el.attr('data-max-infant-capacity'))
    : 10

  self.adults = {
    min: 1,
    max: self.maxAdultCapacity,
    value: self.qs.getParameter('adults') ? parseInt(self.qs.getParameter('adults')) : parseInt(adultsInput.val()),
  }

  self.kids = {
    min: 0,
    max: self.maxKidCapacity,
    value: self.qs.getParameter('kids') ? parseInt(self.qs.getParameter('kids')) : parseInt(kidsInput.val()),
  }

  self.infants = {
    min: 0,
    max: self.maxInfantCapacity,
    value: self.qs.getParameter('infants') ? parseInt(self.qs.getParameter('infants')) : parseInt(infantsInput.val()),
  }

  self.updateCapacities = function () {
    const remainingAdultCapacity = self.maxAdultCapacity > 0 ? (self.maxAdultCapacity - self.adults.value) : self.maxSleepingCapacity - (self.kids.value + self.infants.value)
    if (self.maxAdultCapacity > remainingAdultCapacity) {
      //self.adults.max = remainingAdultCapacity < 0 ? 0 : remainingAdultCapacity
      //} else {
      self.adults.max = self.maxAdultCapacity
    }

    const remainingKidCapacity = self.maxKidCapacity > 0 ? (self.maxKidCapacity - self.kids.value) : self.maxSleepingCapacity - (self.adults.value + self.infants.value)
    if (self.maxKidCapacity > remainingKidCapacity) {
      //  self.kids.max = remainingKidCapacity < 0 ? 0 : remainingKidCapacity
      //} else {
      self.kids.max = self.maxKidCapacity
    }

    const remainingInfantCapacity = self.maxInfantCapacity > 0 ? (self.maxInfantCapacity - self.infants.value) : self.maxSleepingCapacity - (self.adults.value + self.kids.value)
    if (self.maxInfantCapacity > remainingInfantCapacity) {
      //  self.infants.max = remainingInfantCapacity < 0 ? 0 : remainingInfantCapacity
      //} else {
      self.infants.max = self.maxInfantCapacity
    }
  }

  self.updateUI = function () {
    self.updateCapacities()

    let totalGuests = self.adults.value + self.kids.value + self.infants.value
    let totalGuestsText = totalGuests > 1 ? `${totalGuests} Guests` : `${totalGuests} Guest`
    totalGuestsInput.val(totalGuests)
    guestsDisplayInput.val(totalGuestsText)

    if (guestsDisplayEl.length) {
      guestsDisplayEl[0].innerHTML =
        totalGuests > 1 ? `${totalGuests} <span>Guests</span>` : `${totalGuests} <span>Guest</span>`
    }

    adultsValue.text(self.adults.value)
    kidsValue.text(self.kids.value)
    infantsValue.text(self.infants.value)

    adultsInput.val(self.adults.value)
    kidsInput.val(self.kids.value)
    infantsInput.val(self.infants.value)

    if (self.adults.value >= self.adults.max || totalGuests >= self.maxSleepingCapacity) {
      adultsPlusButton.addClass('disabled')
    } else {
      adultsPlusButton.removeClass('disabled')
    }

    if (self.adults.value <= self.adults.min) {
      adultsMinusButton.addClass('disabled')
    } else {
      adultsMinusButton.removeClass('disabled')
    }

    if (self.kids.value >= self.kids.max || totalGuests >= self.maxSleepingCapacity) {
      kidsPlusButton.addClass('disabled')
    } else {
      kidsPlusButton.removeClass('disabled')
    }

    if (self.kids.value <= self.kids.min) {
      kidsMinusButton.addClass('disabled')
    } else {
      kidsMinusButton.removeClass('disabled')
    }

    if (self.infants.value >= self.infants.max || totalGuests >= self.maxSleepingCapacity) {
      infantsPlusButton.addClass('disabled')
    } else {
      infantsPlusButton.removeClass('disabled')
    }

    if (self.infants.value <= self.infants.min) {
      infantsMinusButton.addClass('disabled')
    } else {
      infantsMinusButton.removeClass('disabled')
    }

    //if (self.el.find('.plus-button').hasClass('disabled')) {
    if (totalGuests >= self.maxSleepingCapacity) {
      self.el.addClass('fullcapacity')
    } else {
      self.el.removeClass('fullcapacity')
    }
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('GuestSelector init', self)
    }
    self.el.css('opacity', 1)

    const popupConfig = {
      popup: self.el.find('.selector-popup'),
      on: 'click',
      position: 'bottom center',
      prefer: 'adjacent',
      lastResort: 'bottom right',
    }

    guestsDisplayInput?.popup(popupConfig)
    guestsDisplayEl?.popup(popupConfig)

    self.updateUI()

    window.dbs.globalEvents.subscribe('disableControls', function () {
      self.el.find('button').addClass('loading')
    })

    window.dbs.globalEvents.subscribe('enableControls', function () {
      self.el.find('button').removeClass('loading')
    })

    window.dbs.globalEvents.subscribe('search_popstate', function (state) {
      if (state) {
        self.adults.value = state.filters.adults
        self.kids.value = state.filters.kids
        self.infants.value = state.filters.infants
      } else {
        self.adults.value = ADULTS_DEFAULT_VALUE
        self.kids.value = KIDS_DEFAULT_VALUE
        self.infants.value = INFANTS_DEFAULT_VALUE
      }

      // TODO fix errors when no state passed into function
      let stateFilters = Object.fromEntries(Object.entries(state.filters).filter(([, value]) => value === 0 || !!value))
      // Update URL params with new filter values, but do not reload the page.
      history.replaceState({ filters: stateFilters }, '', window.location.pathname + '?' + $.param(stateFilters))

      self.updateUI()
    })

    $('.clear-filters-button').click(function (event) {
      event.preventDefault()

      self.adults.value = ADULTS_DEFAULT_VALUE
      self.kids.value = KIDS_DEFAULT_VALUE
      self.infants.value = INFANTS_DEFAULT_VALUE

      self.updateUI()
    })

    self.el.find('.plus-button').click(function (e) {
      e.preventDefault()

      if ($(this).hasClass('loading')) return

      let guestType = self[this.getAttribute('data-type')]
      if (guestType.value < guestType.max) {
        guestType.value++
      }


      self.updateUI()

      if ($('.widget.park-map-v2').length !== 0) {
        console.log('Park search page, emitting different event');
        window.dbs.globalEvents.emit('guestselector:updated_parkmap', null, true)
      } else {
        let filters = self.getUpdatedFilters()
        self.pushState(filters)
        window.dbs.globalEvents.emit('guestselector:updated', null, true)
      }
    })

    self.el.find('.minus-button').click(function (e) {
      e.preventDefault()

      if ($(this).hasClass('loading')) return

      let guestType = self[this.getAttribute('data-type')]
      if (guestType.value > guestType.min) {
        guestType.value--
      }

      self.updateUI()
      // Want to only update the adult/children/infant values in the URL
      // Becuase we're refactoring the park search page, don't fire it on that page, it'll be handled there
      if ($('.widget.park-map-v2').length !== 0) {
        console.log('Park search page, emitting different event');
        window.dbs.globalEvents.emit('guestselector:updated_parkmap', null, true)
      } else {
        let filters = self.getUpdatedFilters()
        self.pushState(filters)
        window.dbs.globalEvents.emit('guestselector:updated', null, true)

      }

    })
  }

  self.pushState = function (filters) {
    // Filter out empty values, considering falsely values
    let stateFilters = Object.fromEntries(Object.entries(filters).filter(([, value]) => value === 0 || !!value))
    // Update URL params with new filter values, but do not reload the page.
    history.replaceState({ filters: stateFilters }, '', window.location.pathname + '?' + $.param(stateFilters))
  }

  self.getUpdatedFilters = function () {
    let filters = {
      propertyCode: self.qs.getParameter('propertyCode'),
      arrive: self.qs.getParameter('arrive'),
      depart: self.qs.getParameter('depart'),
      adults: self.adults.value,
      kids: self.kids.value,
      infants: self.infants.value,
      accommodationType: self.qs.getParameter('accommodationType'),
      sort: self.qs.getParameter('sort'),
      maxSearchResults: self.qs.getParameter('maxSearchResults'),
    }

    // NOTE Only add `dealCode` property if we have a value.
    const dealCode = self.qs.getParameter('dealCode')
    if (dealCode) {
      filters.dealCode = dealCode
    }

    return filters
  }
}
